import { IBaseParameter, BaseParameter } from '../base.parameter';

export interface IAppointmentParameter extends IBaseParameter {
  firstday?: string;
  lastday?: string;
  access?: string | 'self' | 'agency';
  block?: number[];
  ic?: number[];
  type?: string | null | 'event' | 'appointment'
}
export class AppointmentParameterDto extends BaseParameter implements IAppointmentParameter {
  /**
   *
   */
  firstday: string;
  lastday: string;
  access: string;
  block?: number[];
  ic?: number[];
  type: string | null | 'event' | 'appointment'

  constructor(partial?: Partial<IAppointmentParameter>) {
    super(partial);
  }
}


// WEBPACK FOOTER //
// ./src/models/appointment/appointment.parameter.ts